module.exports = "/_next/static/images/award-Koran-Sindo-53bee75f43bf14e79ebe186154869fc7.png";